import { labelStyle, valueStyle } from './fileStyle';
import { Container, Text } from 'pixi.js';
import { TranslationText } from './TranslationText';
import { MonoBehavior } from 'game/core/monoBehavior';
import { Layout } from 'game/LayoutManager';
import { Displays } from 'constants/layout';

export class DisplayValue extends MonoBehavior {
    public container: Container;
    public valueContainer: Container;
    public labelContainer: Container;
    public value: Text;
    public label: TranslationText;
    public labelKey: string;

    constructor(labelKey: string) {
        super();
        this.labelKey = labelKey;
        this.value = new Text({ text: 'x', style: valueStyle });
        this.label = new TranslationText(labelKey, labelStyle);
        this.label.text.alpha = 0.7;
        this.container = new Container();
        this.valueContainer = new Container();
        this.labelContainer = new Container();
        this.container.addChild(this.valueContainer);
        this.valueContainer.addChild(this.value);
        this.container.addChild(this.labelContainer);
        this.labelContainer.addChild(this.label.text);
    }
    refresh(): void {
        const device = Layout.getDisplay();
        this.value.anchor.set(0);
        this.label.setAnchor(0);
        this.labelContainer.position.x = 0;
        this.labelContainer.position.y = 0;
        switch (device) {
            case Displays.DESKTOP:
                this.value.anchor.set(0.5);
                this.label.setAnchor(0.5);
                this.valueContainer.position.x = 0;
                this.valueContainer.position.y = 23;
                break;
            case Displays.TABLET:
                this.valueContainer.position.x = this.label.text.width + 8;
                this.valueContainer.position.y = -6;
                break;
            case Displays.MOBILE:
                this.valueContainer.position.x = this.label.text.width + 5;
                this.valueContainer.position.y = -2;
                break;
        }
    }
    getWidth() {
        return this.valueContainer.position.x + this.value.width;
    }
}
